<template>
  <div class="w-full flex flex-col flex-grow min-h-0">
  <!-- Scroll region: the card and its footer, centred -->
    <div class="w-full flex flex-col flex-grow flex-auto h-0 overflow-y-auto">
      <div class="min-h-full w-full flex flex-col items-center justify-center gap-6 px-4 py-10">
      <!-- Card -->
        <div class="panel w-full flex flex-col gap-5 p-6 sm:p-8 text-left" :class="wide ? 'max-w-xl' : 'max-w-sm'">
        <!-- Badge and wordmark -->
          <div v-if="lockup" class="flex flex-row items-center justify-center gap-2.5">
            <img src="@/assets/dls-badge.svg" alt="" class="h-[30px] w-auto dark:hidden">
            <img src="@/assets/dls-badge-reverse.svg" alt="" class="h-[30px] w-auto hidden dark:block">
            <DLSTrackerLogo class="h-[19px] w-auto text-neutral-500 dark:text-neutral-100" />
          </div>
        <!-- Header -->
          <div class="flex flex-col gap-1.5">
            <div v-if="icon" class="w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-1" :class="toneClass">
              <component :is="icon" class="w-5 h-5" />
            </div>
            <h1 class="text-base font-semibold text-center">{{ title }}</h1>
            <div v-if="$slots.subtitle" class="text-sm opacity-80 whitespace-normal text-center"><slot name="subtitle" /></div>
          </div>
          <slot />
        </div>
      <!-- Footer -->
        <div class="flex flex-col items-center gap-1 text-[11px] opacity-60">
          <div>For authorized use only</div>
          <div>© {{ year }} Digital Labor Solutions</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import DLSTrackerLogo from '@/components/ui/DLSTrackerLogo.vue'

// The layout every sign-in screen uses: optional lockup, an icon and title, the screen's body, and the footer.
export default {
  name: 'AuthCard',
  components: { DLSTrackerLogo },
  props: {
    title: { type: String, required: true },
    lockup: { type: Boolean, default: false },
    icon: { type: Object, default: null },
    tone: { type: String, default: 'sky', validator: (v) => ['sky', 'green', 'amber'].includes(v) },
    // Wider card for longer text (the sign-in prompts and their consent wording).
    wide: { type: Boolean, default: false }
  },
  setup(props) {

  // Computed
    const toneClass = computed(() => ({
      sky: 'bg-sky-500/10 text-sky',
      green: 'bg-green-500/10 text-green',
      amber: 'bg-amber-500/10 text-amber'
    })[props.tone] || 'bg-sky-500/10 text-sky')
    const year = new Date().getFullYear()

    return { toneClass, year }
  }
}
</script>
